import { Button, EditableSectionContainer, EditableSectionRowTip, LoadableTypography, useEditableSectionsContext } from '@uplift/ui-v2';
import { MatchingProfileRow } from '@uplift/types';
import { useProfileContext } from '../profile.context';
import { BioForm, useProfileFormikConfigs } from '../forms';
import { profileRowKeyToLabel, useDisplayInvalidRows } from '../profile.utils';
import { useProfileStyles } from '../styles';
import { Box, List, ListItem, Typography } from '@mui/material';
import clsx from 'clsx';
import { RequiredProfileEditableSectionRow } from '../components/RequiredProfileRow.component';
import { useIsMobile } from '@uplift/hooks';

export const BioSection: React.FC = () => {
  const { classes } = useProfileStyles();
  const { profile, loading } = useProfileContext();
  const { editKey, setEditKey } = useEditableSectionsContext();
  const { getFormikConfig } = useProfileFormikConfigs();
  const isMobile = useIsMobile('sm');
  const invalidRows = useDisplayInvalidRows();
  const bioInvalid = invalidRows.includes(MatchingProfileRow.bio);

  return (
    <EditableSectionContainer
      title="Your bio"
      formikConfigs={{
        [MatchingProfileRow.bio]: getFormikConfig(MatchingProfileRow.bio),
      }}
      actions={isMobile && bioInvalid && <Button variant="contained" color="secondary" onClick={() => setEditKey(MatchingProfileRow.bio)}>Add</Button>}
    >
      <RequiredProfileEditableSectionRow
        label={editKey !== MatchingProfileRow.bio ? profileRowKeyToLabel.bio : undefined}
        rowKey={MatchingProfileRow.bio}
        kind="editable-row"
        form={<BioForm />}
        hideLabel
        hideEditButton={isMobile && bioInvalid}
        editTip={(
          <EditableSectionRowTip
            title="Tip"
            description={(
              <Box display="flex" flexDirection="column" gap="0.5rem">
                <Typography className={classes.fontSize14}>Let your clinical experience in the rest of your profile speak for itself. Therapy is a personal relationship that asks clients to be vulnerable—so use this space to show your personality and let clients get to know you.</Typography>
                <Typography className={clsx(classes.fontSize14, classes.fontWeight600)}>Here’s some ideas:</Typography>
                <List className={classes.discList} disablePadding>
                  {[
                    'Use plain language that mirrors clients’ emotional state, such as “uncertainty” or feeling “stuck.”',
                    'Include values you practice.',
                    'Write the change or growth you hope clients experience through your therapy.',
                    'Center clients using “you,” e.g. “Meet your full potential” or “Things can get better for you.”',
                  ].map((item, index) => (
                    <ListItem key={index} className={clsx(classes.fontSize14, classes.discListItem)} disableGutters>{item}</ListItem>
                  ))}
                </List>
              </Box>
            )}
          />
        )}
      >
        <LoadableTypography
          width="100%"
          loading={loading}
          className={classes.prewrap}
        >
          {profile?.profile?.shortBio}
        </LoadableTypography>
      </RequiredProfileEditableSectionRow>
    </EditableSectionContainer>
  );
};
